import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getPastEventPageData = async () => {
  const data = await fetchData(ENDPOINTS.GET.PAST_EVENTS_PAGE, {
    method: METHODS.GET,
  });
  return data;
};
